import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Menu from '../_models/menu.model';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private menu: Menu[];

  constructor(private router: Router, private route: ActivatedRoute) {
    this.menu = [
      {
        nome: 'LandingPage',
        link: '/',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: false,
        header: {
          exibir: false,
        },
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Promoção',
        link: '/promocao',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: false,
        header: {
          exibir: false,
        },
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Palito Premiado',
        link: '/palito-premiado',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: false,
        header: {
          exibir: false,
        },
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Página Inicial',
        link: '/home',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: false,
        header: {
          exibir: false,
        },
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Início',
        link: '/index',
        linkExterno: false,
        icone: '',
        logado: true,
        header: {
          exibir: true,
        },
        listar: true,
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Extrato',
        link: '/extrato',
        linkExterno: false,
        icone: '',
        logado: true,
        listar: false,
        header: {
          exibir: true,
        },
        subheader: {
          exibir: true,
          titulo: 'Extrato',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Experiências',
        link: '/momento-especial/0',
        linkExterno: false,
        icone: '',
        logado: true,
        header: {
          exibir: true,
        },
        listar: false,
        subheader: {
          exibir: true,
          titulo: 'Conheça o momento especial',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Momentos Especiais',
        link: '/momentos-especiais',
        linkExterno: false,
        icone: '',
        header: {
          exibir: true,
        },
        listar: true,
        logado: true,
        subheader: {
          exibir: false,
          titulo: 'Exclusivos Cacau Show',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Minhas Experiências',
        link: '/minhas-experiencias',
        linkExterno: false,
        icone: '',
        header: {
          exibir: true,
        },
        logado: true,
        listar: false,
        subheader: {
          exibir: true,
          titulo: 'Meus Momentos Especiais',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: '',
        link: '/notificacoes',
        linkExterno: false,
        icone: 'assets/images/icons/sino.png',
        iconeHover: 'assets/images/icons/sino_hover.png',
        iconeOut: 'assets/images/icons/sino.png',
        listar: false,
        header: {
          exibir: true,
        },
        logado: true,
        subheader: {
          exibir: true,
          titulo: 'Notificações',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Redefinição de Senha',
        link: '/esquecisenha',
        linkExterno: false,
        icone: '',
        header: {
          exibir: true,
        },
        listar: false,
        logado: false,
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: false,
        },
      },
      {
        nome: 'Resetar Senha',
        link: '/resetarsenha',
        linkExterno: false,
        icone: '',
        header: {
          exibir: true,
        },
        listar: false,
        logado: false,
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: false,
        },
      },
      {
        nome: 'Meus Dados',
        link: '/meusdados',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: true,
        header: {
          exibir: true,
        },
        subheader: {
          exibir: true,
          titulo: 'Meus Dados',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Ajuda',
        link: '/ajuda/:tipo',
        linkExterno: false,
        icone: '',
        listar: false,
        header: {
          exibir: true,
        },
        logado: true,
        subheader: {
          exibir: false,
          titulo: 'Ajuda',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Lovers pela causa',
        link: '/pela-causa',
        linkExterno: false,
        icone: '',
        listar: false,
        header: {
          exibir: true,
        },
        logado: false,
        subheader: {
          exibir: false,
          titulo: 'Lovers Pela Causa',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Lovers pela causa',
        link: '/lovers-pela-causa',
        linkExterno: false,
        icone: '',
        listar: false,
        header: {
          exibir: true,
        },
        logado: true,
        subheader: {
          exibir: false,
          titulo: 'Lovers Pela Causa',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Desafios',
        link: '/desafios',
        linkExterno: false,
        icone: '',
        listar: false,
        header: {
          exibir: true,
        },
        logado: true,
        subheader: {
          exibir: true,
          titulo: 'Missões',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Solicitacoes',
        link: '/solicitacoes',
        linkExterno: false,
        icone: '',
        listar: false,
        header: {
          exibir: true,
        },
        logado: true,
        subheader: {
          exibir: true,
          titulo: 'Detalhes',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Indicacoes',
        link: '/indicacoes',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: true,
        header: {
          exibir: true,
        },
        subheader: {
          exibir: true,
          titulo: 'Indicações',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Missões',
        link: '/missoes',
        linkExterno: false,
        icone: '',
        listar: true,
        logado: true,
        header: {
          exibir: true,
        },
        subheader: {
          exibir: true,
          titulo: 'Conclua as missões e ganhe recompensas',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Remoção Comunicação',
        link: '/remocao',
        linkExterno: false,
        icone: '',
        header: {
          exibir: true,
        },
        listar: false,
        logado: false,
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Cadastro Parceiros',
        link: '/cadastro_parceiros',
        linkExterno: false,
        icone: '',
        header: {
          exibir: true,
        },
        listar: false,
        logado: false,
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Benefícios',
        link: '/beneficios',
        linkExterno: false,
        icone: '',
        listar: true,
        logado: true,
        header: {
          exibir: true,
        },
        subheader: {
          exibir: true,
          titulo: 'Confira todos os Benefícios Lovers disponíveis para você!',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'O Programa',
        link: '/programa',
        linkExterno: false,
        icone: '',
        listar: true,
        logado: true,
        header: {
          exibir: true,
        },
        subheader: {
          exibir: false,
          titulo: 'Confira todos os Benefícios Lovers disponíveis para você!',
          exibirSaldoPontuacao: true,
        },
        footer: {
          exibir: true,
        },
      },
      {
        nome: 'Login Redirect',
        link: '/loginredirect',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: false,
        header: {
          exibir: false,
        },
        subheader: {
          exibir: false,
          titulo: '',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: false,
        },
      },
      {
        nome: 'Valida Dados',
        link: '/validar-dados',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: false,
        header: {
          exibir: true,
        },
        subheader: {
          exibir: false,
          titulo: 'Valida Dados',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: false,
        },
      },
      {
        nome: 'Validar Dados',
        link: '/validar-dados',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: false,
        header: {
          exibir: true,
        },
        subheader: {
          exibir: false,
          titulo: 'Valida Dados',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: false,
        },
      },
      {
        nome: 'Logout',
        link: '/logout',
        linkExterno: false,
        icone: '',
        listar: false,
        logado: true,
        header: {
          exibir: false,
        },
        subheader: {
          exibir: false,
          titulo: 'Logout',
          exibirSaldoPontuacao: false,
        },
        footer: {
          exibir: false,
        },
      },
    ];
  }

  public obterMenu(): Menu[] {
    return this.menu;
  }

  public obterMenuDeslogado(): Menu[] {
    const menus: Menu[] = [];

    this.menu.forEach((menuItem: Menu) => {
      if (!menuItem.logado) menus.push(menuItem);
    });

    return menus;
  }

  public obterMenuLogado(): Menu[] {
    const menus: Menu[] = [];

    this.menu.forEach((menuItem: Menu) => {
      if (menuItem.logado && menuItem.listar) menus.push(menuItem);
    });

    return menus;
  }

  public obterPaginaPorLink(link: string): Menu | null {
    link = link.split('/')[1] === undefined ? '' : link.split('/')[1];

    if (link.includes('?')) link = link.split('?')[0];
    if (link.includes('resetarsenha')) link = 'resetarsenha';

    for (let i = 0; i < this.menu.length; i++) {
      let menuItemLink =
        this.menu[i].link.split('/')[1] === undefined
          ? ''
          : this.menu[i].link.split('/')[1];

      if (menuItemLink === link) return this.menu[i];
    }

    return null;
  }

  public irPara(menuItem: Menu): void {
    if (menuItem.linkExterno) {
      window.open(menuItem.link, '_blank');
      return;
    }

    this.router.navigate([menuItem.link]);
  }

  public irParaPorLink(link: string, linkExterno: boolean = false): void {
    if (linkExterno) {
      window.open(link, '_blank');
      return;
    }

    this.router.navigate([link]);
  }

  public irParaLinkOuNavigate(link: string): void {
    if (link.includes('http') || link.includes('https')) {
      window.open(link, '_blank');
      return;
    }

    this.router.navigate([link]);
  }
}
